/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Themes the Spin-to-Win client can render.
 * 
 * The game's theme stays a plain string on S2WGame rather than becoming this enum: the field is part
 * of the published browser client's contract, and narrowing it there would break clients that assign
 * their own theme constants into it. Imports are checked against this list instead, so an
 * unrecognised theme is rejected at the boundary rather than stored -- the client falls back to its
 * default theme for a value it does not know, which presents as a styling bug rather than bad data.
 * 
 * A new theme has to be added here before a game can be imported using it.
 * @export
 */
export const S2WTheme = {
    DEFAULT: 'DEFAULT',
    HIGH_ROLLER: 'HIGH_ROLLER',
    VEGAS: 'VEGAS',
    MICHIGAN_THEME_01: 'MICHIGAN_THEME_01',
    unknown_default_open_api: '11184809'
} as const;
export type S2WTheme = typeof S2WTheme[keyof typeof S2WTheme];


export function instanceOfS2WTheme(value: any): boolean {
    for (const key in S2WTheme) {
        if (Object.prototype.hasOwnProperty.call(S2WTheme, key)) {
            if (S2WTheme[key as keyof typeof S2WTheme] === value) {
                return true;
            }
        }
    }
    return false;
}

export function S2WThemeFromJSON(json: any): S2WTheme {
    return S2WThemeFromJSONTyped(json, false);
}

export function S2WThemeFromJSONTyped(json: any, ignoreDiscriminator: boolean): S2WTheme {
    return json as S2WTheme;
}

export function S2WThemeToJSON(value?: S2WTheme | null): any {
    return value as any;
}

